import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Trophy, Flame, ChevronRight, Rocket } from "lucide-react";
import api from "@/lib/api";

export default function RaceWidget() {
  const navigate = useNavigate();
  const [r, setR] = useState(null);

  useEffect(() => { api.get("/arcade/my-race").then((res) => setR(res.data)).catch(() => setR(false)); }, []);

  if (!r || r === false) return null;
  if (!r.published) return null; // only relevant once a creator has a published game

  const go = () => navigate("/app/creator-race");

  return (
    <button onClick={go} data-testid="race-widget"
      className="w-full text-left rounded-2xl border border-amber-400/30 bg-gradient-to-r from-amber-400/[0.10] to-orange-500/[0.05] p-4 mb-6 flex items-center gap-4 card-hover">
      <div className="w-12 h-12 shrink-0 rounded-xl grid place-items-center bg-amber-400/15 border border-amber-400/30">
        <Trophy className="w-6 h-6 text-amber-400 fill-amber-400" />
      </div>
      <div className="flex-1 min-w-0">
        {!r.in_race ? (
          <>
            <div className="font-display font-extrabold flex items-center gap-1.5"><Rocket className="w-4 h-4 text-amber-400" /> Join the weekly race</div>
            <div className="text-xs text-[hsl(var(--muted-foreground))]">Get plays, followers and tips this week to climb the Creator of the Week board</div>
          </>
        ) : (
          <>
            <div className="font-display font-extrabold" data-testid="race-widget-rank">
              You're <span className="text-amber-500">#{r.rank}</span> in this week's race
              <span className="text-[hsl(var(--muted-foreground))] font-normal"> of {r.total}</span>
            </div>
            <div className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-3 mt-0.5">
              <span className="flex items-center gap-1"><Flame className="w-3 h-3 text-orange-400" /> {r.score} momentum</span>
              {r.ahead
                ? <span data-testid="race-widget-hint">🎯 {r.ahead.plays_to_climb} play{r.ahead.plays_to_climb === 1 ? "" : "s"} to pass #{r.ahead.rank} ({r.ahead.owner_name})</span>
                : <span className="text-amber-500 font-semibold" data-testid="race-widget-hint">🏆 You're #1 — you're the Creator of the Week!</span>}
            </div>
          </>
        )}
      </div>
      <ChevronRight className="w-5 h-5 text-[hsl(var(--muted-foreground))] shrink-0" />
    </button>
  );
}
